<template>
    <div id='SearchBox'>
        <form class='SearchForm' @submit.prevent='findItem'>
            <DisplayIcon v-if='!rightSideIcon'
                name='Product Search'
                icon='SearchIcon'
             />
             <!--<form @submit.prevent='findItem'> -->
                <TextBox
                    label=''
                    store='ItemCard'
                    name='productSkuSearch'
                    placeholder='Search For A SKU'
                />
           <!-- </form> -->
            <span class='ItemSearchError' v-if="(skuError != '')">{{ skuError }}</span>
        </form>
    </div>
</template>

<script>
    import DisplayFormInput from './DisplayFormInput';
    import TextBox from './TextBox';
    import DisplayIcon from '../../icons/DisplayIcon';
    export default {
        name:'Search',
        props:['iconSide'],
        components: {
            DisplayIcon,
            DisplayFormInput,
            TextBox
        },
        data(){
            return {
                SKU: 'Search For A SKU',
                textBoxValue: 'Search For A SKU',
                textBoxName: 'searchedItem',
                BoxClassName: 'searchBox ml-2'
            }
        },
        computed:{
            skuError(){
                return this.$store.getters['ItemInfo/productFetchError']
            },
            rightSideIcon(){
                return this.$props.iconSide == "right";
            },
            currentProduct(){
                return this.$store.state.ItemInfo
            },
            productCollection(){
                return this.$store.getters['ProductCollection/productCollection']
            }
        },
        methods: {
            matchPartial(e){
                console.log(e.target.value);
            },
            findItem(e){
                //QNB0PBHEPH006
                console.log('finditem called');
                console.log('finditem: '+ e.target.productSkuSearch.value);
                this.$store.commit('Navigation/setModuleNavs', []);
                
                this.$store.dispatch('ItemCard/fetchItem', {sku: e.target.productSkuSearch.value, store: 'ItemCard'})
                    .then(() => {
                        console.log('returned?');
                        this.$store.dispatch('Navigation/addNotification',{
                            icon: 'SearchIcon',
                            header: 'Item Search',
                            message: 'Search for: ' + e.target.productSkuSearch.value,
                            type: (this.skuError == '') ? 'success' : this.skuError
                        });
                        this.saveProduct()
                        })
                    .catch((error) => {
                    //commit('setFetchError', error)
                        console.log('error returning promise: ' + error)
                    });
            },
            onFocus(e){
                 e.target.value = '';
            },
            saveProduct(){
                console.log("save product called????")
                let tempProduct = {};
                for(const item in this.currentProduct){
                    console.log('item: '+`${item} -> ${this.currentProduct[item]}`);
                    console.log('item alone: '+ item);
                    let itemName = item;
                    if(itemName != 'productCollection'){
                        Object.assign(tempProduct, {[itemName]:  this.currentProduct[item]});
                    }
                    //this.$store.commit('ItemInfo/addToProduct', {itemName: item, value: this.currentProduct[item]})
                    
                };
                //console.log('tempProduct: ' + Object.entries(tempProduct));
                this.$store.dispatch('ProductCollection/set', {field: 'selectedProduct', value: tempProduct})
                let tempProductCollection = this.productCollection;
                console.log('pushing: '+ tempProduct + ' into - '+ this.productCollection)
                if(tempProductCollection.findIndex(x => x.productSku == tempProduct.productSku) == -1){
                    tempProductCollection.push(tempProduct);
                    this.$store.dispatch('ProductCollection/set', {field: 'productCollection', value: tempProductCollection})
                }
            }
        }
    }
</script>